module.exports = __webpack_public_path__ + "img/logo.26a24e94.png";